import React, { Component } from 'react';
import beautify from 'xml-beautifier';

class XmlViewer extends Component {
  render() {
    const { data } = this.props;
    const beautified = beautify(data);
    return <pre>{beautified}</pre>;
  }
}

export default XmlViewer;
